import { Container, Heading3 } from "shared/components";

import styles from "./Content042.module.scss";
import { Item } from "./Item";

export const Content042 = ({ payload }) => {
  const title = payload?.title ?? "";
  const items = payload?.items ?? [];

  return (
    <div className={styles.wrapper}>
      <Container>
        <Heading3 className={styles.title}>{title}</Heading3>
        <div className={styles.content}>
          <div className={styles.items}>
            {items.map((item) => (
              <Item item={item} key={item.id} />
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content042;
